import { z } from 'zod';

/** Read provenance is required: a degraded snapshot is not a verified zero. */
export const VoiceChannelCounterStateSchema = z.object({
  scope: z.enum(['cluster', 'process']),
  state: z.enum(['verified', 'degraded']),
  reason: z.enum([
    'local_backend',
    'redis_unavailable',
    'fs_snapshot_incomplete',
    'fs_snapshot_stale',
    'fs_snapshot_unknown',
  ]).nullable(),
});
export type VoiceChannelCounterState = z.infer<typeof VoiceChannelCounterStateSchema>;

export const VoiceChannelCountSnapshotSchema = z.object({
  current: z.number().int().nonnegative(),
  counter: VoiceChannelCounterStateSchema,
});
export type VoiceChannelCountSnapshot = z.infer<typeof VoiceChannelCountSnapshotSchema>;

export const ChannelUsageStatsSchema = z.object({
  tenant_id: z.string(),
  current_channels: z.number().int().nonnegative(),
  max_channels: z.number().int().nonnegative(),
  over_limit_count_today: z.number().nonnegative(),
  over_limit_count_month: z.number().nonnegative(),
  total_seconds_today: z.number().nonnegative(),
  total_seconds_month: z.number().nonnegative(),
  peak_channels_today: z.number().nonnegative(),
  peak_channels_month: z.number().nonnegative(),
  counter: VoiceChannelCounterStateSchema,
});
export type ChannelUsageStats = z.infer<typeof ChannelUsageStatsSchema>;

export const TenantChannelStatusSchema = z.object({
  tenant_id: z.string(),
  tenant_name: z.string(),
  tenant_product: z.string().nullable(),
  current_channels: z.number().int().nonnegative(),
  max_channels: z.number().int().nonnegative(),
  usage_percent: z.number().nonnegative(),
  counter: VoiceChannelCounterStateSchema,
});
export type TenantChannelStatus = z.infer<typeof TenantChannelStatusSchema>;

export const TrunkChannelUsageSchema = z.object({
  trunk_id: z.string(),
  trunk_name: z.string(),
  current_channels: z.number().int().nonnegative(),
  max_channels: z.number().int().nonnegative(),
  usage_percent: z.number().nonnegative(),
  counter: VoiceChannelCounterStateSchema,
});
export type TrunkChannelUsage = z.infer<typeof TrunkChannelUsageSchema>;

export const SipTrunkChannelInfoSchema = z.object({
  tenant: z.object({
    max_channels: z.number().int().nonnegative(),
    current_channels: z.number().int().nonnegative(),
    usage_percent: z.number().nonnegative(),
    allocated_to_trunks: z.number().int().nonnegative(),
    unallocated: z.number().int(),
    counter: VoiceChannelCounterStateSchema,
  }),
  trunks: z.array(TrunkChannelUsageSchema),
});
export type SipTrunkChannelInfo = z.infer<typeof SipTrunkChannelInfoSchema>;
